export default __webpack_public_path__ + "static/SFMono-RegularItalic-f8e0001df4ca100d2de026d7b7cd5ab5.ttf";